export default "__VITE_ASSET__BPF9AFno__"